export interface FetchErkomByIDResponse {
    status: boolean;
    message: string;
    data: ErkomByID;
}

export interface ErkomByID {
  id: number;
  status: string;
  institutionId: number;
  clientFullname: string;
  patientId: number;
  patientFullname: string;
  patientIdNumber: string;
  patientGender: string;
  patientBirthdate: string;
  patientAddress: string;
  patientHealthPlan?: string;
  patientPrepaid?: string;
  patientPhoneNumber: string;
  patientEmail: string;
  patientIdCard: string;
  material: string;
  size: string;
  cryoanalgesia: boolean;
  observation: string | null;
  surgeryTest: boolean;
  fakeSurgery: string;
  fakeSurgeryCompleted: boolean;
  fakeSurgerySelect?: string | null;
  surgery: string;
  surgery_date: string;
  surgeryLocationId: number;
  procedure: string;
  procedure_id: number;
  implant_test: string | null;
  implants: ImplantsData[] | null;
  implants_min: number | null;
  implants_max: number | null;
  number_implants: number;
  medicId: number;
  institution_id: number;
  institution_name: string;
  status_id: number;
  comercial_status_id: number;
  allowed_clinical_states: AllowedClinicalState[];
  allowed_comercial_states: AllowedClinicalState[];
  clinicalsStatusEntries: ClinicalStatusEntries[];
  comercialsStatusEntries: ComercialStatusEntries[];

  needImplantTest: null | boolean;
  implantTestStatus: ImplantTestStatus | null;
  file?: any;
  zip_path?: string;
  tutor_name?: string | null;
}

export interface AllowedClinicalState{
    id: number,
    status: string
}

export interface ClinicalStatusEntries {
    status_id: number,
    isCompleted: string | null;
}

export interface ComercialStatusEntries {
  status_id: number,
  isCompleted?: string | null,
  quotation?: string | null,
  bill?: string | null,
  bill_code?: string | null,
  manufacturing_code?: string | null,
  manufacturing_status?: boolean | null,
  referral?: string | null,
  referral_code?: string | null,
}

export interface ImplantTestStatus{
  status: string,
  observations: string | null;
}

export interface ClinicalStatus{
  tomography: boolean;
  designedImplants: boolean;
  designedImplantsSelect: string | null;
  requiresImplantTest: string | null;
  templatesReceived:boolean;
  templatesSend: boolean;
  clinicalStatusComplete: boolean;
};

export interface ImplantsData {
  id: number;
  name: string;
};

export interface ComercialStatesDocumentsPayload {
  new_status_id: string;
  quotation?: File | null;
  bill?: File | null;
  bill_code?: string;
  manufacturing_code?: string;
  manufacturing_status?: boolean;
  referral?: File | null;
  referral_code?: string;
};